import React from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import Error404Image from "../../assets/images/404.png";
import { useLanguage } from "../../context/LanguageContext";

const Error404 = () => {
  const { language } = useLanguage();
  document.title = language === "pt" ? "Erro 404" : "Error 404";

  return (
    <React.Fragment>
      <div>
        <div className="main-content">
          <div className="page-content">
            <section className="bg-error bg-auth text-dark">
              <Container>
                <Row className="justify-content-center">
                  <Col lg={6}>
                    <div className="text-center">
                      <img src={Error404Image} alt="" className="img-fluid" />
                      <div className="mt-5">
                        <h4 className="text-uppercase mt-3">
                          {language === "pt" ? "Desculpe, página não encontrada" : "Sorry, page not found"}
                        </h4>
                        <div className="mt-4">
                          <Link
                            className="btn btn-primary waves-effect waves-light"
                            to="/"
                          >
                            <i className="mdi mdi-home"></i>
                            {language === "pt" ? "Voltar para a Página Inicial" : "Go back to home page"}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Error404;
